import React, { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import ItemDetailHeader from './ItemDetailHeader'
import ItemRelationships from './ItemRelationships'
import ItemContext from '../../context/item/ItemContext'
import { CardContainer, ListContainer } from '../layout/Containers'
import { Spinner } from '../layout/Spinner'
import { withComponentLabel } from '../../utils/debug'

const ItemDetailPage = () => {
  const itemContext = useContext(ItemContext)
  const { itemId } = useParams()

  const { currentItem, setCurrentItem, getItem } = itemContext
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadItem = async () => {
      const item = await getItem(itemId)
      setCurrentItem(item)
      setLoading(false)
    }
    loadItem()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <ListContainer>
        <CardContainer>
          {loading ? (
            <Spinner />
          ) : (
            currentItem && (
              <ItemDetailPageContent currentItem={currentItem} />
            )
          )}
        </CardContainer>
      </ListContainer>
    </>
  )
}

const ItemDetailPageContent = (props) => {
  const navigate = useNavigate()
  const { currentItem } = props
  const itemContext = useContext(ItemContext)
  const { clearCurrentItem, deleteItem } = itemContext

  const onDeleteItemClick = async () => {
    await deleteItem(currentItem._id)
    clearCurrentItem()
    navigate(-1)
  }

  return (
    <>
      <ItemDetailHeader
        deleteClick={onDeleteItemClick}
        item={currentItem}
        changeAction={() => console.log('change action')}
      />
      
      <ItemRelationships itemId={currentItem._id} />
    </>
  )
}

export default withComponentLabel(ItemDetailPage, 'ItemDetailPage')